import React from 'react';
import Spritesheet_Loading from './Spritesheets/Spritesheet_Loading';
import '../styles/loading.scss'

const Loading = () => {
return (
    <div className = "loading">
        <img />
        <Spritesheet_Loading />
    </div>
    );
}

export default Loading;